<template>
  <div>
    <header>
        <div class="content">
            <div class="logo"><img src="./../../assets/images/logo2.png" alt="logo"></div>
            <div class="head-nav">
                <ul class="nav-list">
                    <li class="list-item" :class="pageName=='home'?'active':''" @click="router('home')">Home Page</li>
                    <li class="list-item" :class="pageName=='cooperation'?'active':''" @click="router('cooperation')">Cooperation</li>
                    <li class="list-item" :class="pageName=='contact'?'active':''" @click="router('contact')">Contact Us</li>
                    <li class="list-item"><a href="https://ebooking.cnbooking.net/#/" >中文版</a></li>
                </ul>
            </div> 
        </div>
    </header>
  </div>
</template>
<script>
export default {
  name:'header',
    props:{
    	pageName:{
    		type:String,
    		default:''
    	},
    },
    methods:{
      router(url){
        if(url==this.pageName)return;
        if(url=='cooperation'){
          this.routetoPage('/hotelJoin')
        }else if(url=='contact'){
          this.routetoPage('/contactUs')
        }else{
          this.routetoPage('/')
        }
        
      }
    }
}

</script>




// WEBPACK FOOTER //
// src/common/header/header.vue